<template>
  <TabsList
    v-bind="delegatedProps"
    :class="
      cn(
        'tw:inline-flex tw:items-center tw:border-b tw:w-full tw:gap-2',
        'tw:flex-wrap',
        props.class,
      )
    "
  >
    <slot />
  </TabsList>
</template>

<script setup>
import { reactiveOmit } from '@vueuse/core'
import { TabsList } from 'reka-ui'
import { cn } from '@/shadcn/lib/utils'

const props = defineProps({
  loop: { type: Boolean, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: [String, Object, Function], required: false },
  class: { type: null, required: false },
})

const delegatedProps = reactiveOmit(props, 'class')
</script>
